import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import CreatePurchaseOrderModal from "../../modals/PurchaseOrder/CreatePurchaseOrderModal";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import PODropdown from "./PODropdown";
import Swal from "sweetalert2";
import SQDropdown from "./SQDropdown";
import WODropdown from "./WODropdown";
import resData from "../../Data/reponse_json.json";
import POSummaryDropdown from "./POSummaryDropdown";

const WorkOrderRMStatus = () => {
    const location = useLocation();
    const data = location.state?.data || null;
    // console.log(data);
    const [currentItem, setCurrentItem] = useState(null);

    const { useFetch } = useAPIQuery({
        key: "requierement-analysis",
        endpoint: "/api/requirement-analysis-updated-2/",
    });

    const requirementData = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: true,
        staleTime: 300000,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const columnsRM = [
        {
            accessor: "item_code",
            header: "Item Id",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "required_quantity",
            header: "Total required quantity",
            cell: (row) => <>{row?.required_quantity?.toFixed(2)}</>,
        },
        {
            accessor: "work_order",
            header: "Work Orders",
            cell: (row) => (
                <div
                    className="d-flex justify-content-between"
                    style={{ width: "100%" }}
                >
                    <span>{row?.work_order?.[0]}</span>
                    <WODropdown row={row} />
                </div>
            ),
        },
        {
            accessor: "stock_quantity",
            header: "Stock Quantity",
            cell: (row) => (
                <div
                    className="d-flex justify-content-between"
                    style={{ width: "100%" }}
                >
                    <span>{row?.stock_quantity?.toFixed(2)}</span>
                    {/* <SQDropdown row={row} /> */}
                </div>
            ),
        },
        {
            accessor: "order_quantity",
            header: "Stock Shortage",
            cell: (row) => (
                <div
                    className="d-flex justify-content-between"
                    style={{ width: "100%" }}
                >
                    <span>{row?.order_quantity?.toFixed(2)}</span>
                    {row?.purchase_orders?.length !== 0 ? (
                        <PODropdown row={row} />
                    ) : null}
                </div>
            ),
        },
        {
            accessor: "po_summary",
            header: "PO Summary",
            cell: (row) => (
                <div
                    className="d-flex justify-content-between"
                    style={{ width: "100%" }}
                >
                    {row?.purchase_orders?.length !== 0 ? (
                        <POSummaryDropdown row={row} />
                    ) : null}
                </div>
            ),
        },
        {
            accessor: "uom",
            header: "UOM",
        },
        {
            accessor: "create_po",
            header: "Action",
            cell: (row) => (
                <button
                    className="btn btn-sm btn-primary"
                    data-bs-target={`#create-po-modal`}
                    data-bs-toggle="modal"
                    onClick={() => setCurrentItem(row)}
                >
                    Create PO
                </button>
            ),
        },
    ];

    useEffect(() => {
        if (requirementData.data?.data?.length <= 0) {
            Swal.fire({
                title: "No data to display",
                text: requirementData.data?.message,
                icon: "error",
            });
        }
    }, [requirementData]);

    // useEffect(() => {
    //     const handleBeforeUnload = (e) => {
    //         e.preventDefault();
    //         e.returnValue = "";
    //     };

    //     window.addEventListener("beforeunload", handleBeforeUnload);

    //     return () => {
    //         window.removeEventListener("beforeunload", handleBeforeUnload);
    //     };
    // }, []);

    return (
        <div>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Requirement Analysis
                        </h3>
                    </div>
                </div>
                <CreatePurchaseOrderModal row={currentItem} />
            </div>
            <Table
                data={requirementData.data ? requirementData.data?.data : []}
                // data={resData?.data ?? []}
                columns={columnsRM}
                isLoading={
                    requirementData.isLoading || requirementData.isFetching
                }
                pagination={false}
                selectRows={false}
                globalSearch={false}
                filterModal={false}
                editRows={false}
                deleteRows={false}
                maxHeight={600}
            />
        </div>
    );
};

export default WorkOrderRMStatus;
